import script from "./ProductSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSearch.vue?vue&type=script&setup=true&lang=js"

import "./ProductSearch.vue?vue&type=style&index=0&id=63907d3b&lang=less"

const __exports__ = script;

export default __exports__